export const SingleTab = 'atlantis-single-tab-panel';
export const MultiTab = 'atlantis-multi-tab-panel';
export const MultiTabHeader = 'atlantis-multi-tab-panel-header';
export const MultiTabBody = 'atlantis-multi-tab-panel-body';
export const MultiTabHeaderItem = 'atlantis-multi-tab-panel-header-item';
